import cn from 'classnames';
import React from 'react';

import { Portal } from 'components';
import Sidebar from '../Sidebar';
import Footer from '../Footer';
import SidebarToggler from '../SidebarToggler';
import useBetslipSidebarWrapper from './useBetslipSidebarWrapper';
import './betslipSidebarWrapper.scss';

const BetslipSidebarWrapper: React.FC = () => {
    const props = useBetslipSidebarWrapper();

    if (!props) return null;

    const {
        isLarge,
        canToggle,
        parentNode,
        isAuthorized,
        ignoreOffsetInTheaterMode,
    } = props;

    const conditionalStyleNames = {
        'is-offset-ignored-in-theater-mode': ignoreOffsetInTheaterMode,
    };

    if (parentNode) {
        return (
            <Portal isPageDisabled={false} parentNode={parentNode}>
                <div styleName={cn('portal-container', conditionalStyleNames)}>
                    {canToggle ? (
                        <SidebarToggler />
                    ) : (
                        <Sidebar isAuthorized={isAuthorized} />
                    )}
                </div>
            </Portal>
        );
    }

    return (
        <div styleName={cn('container', conditionalStyleNames)}>
            {isLarge || canToggle ? (
                <Footer />
            ) : (
                <Sidebar isAuthorized={isAuthorized} />
            )}
        </div>
    );
};

export default React.memo(BetslipSidebarWrapper);
